// Filename - components/searchbar/Searchbar.js


import React, { useState, useEffect, useRef } from "react";
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import {searchIcon, clipboardIcon} from '@workday/canvas-system-icons-web';
import {SystemIcon} from '@workday/canvas-kit-react/icon';
import { searchItems } from "./SearchbarData";
import InputBase from '@material-ui/core/InputBase';
import './Searchbar.css'
const useStyles = makeStyles((theme) => ({
    search: {
        '&:hover': {
            borderColor: "#62749a !important"
        },
        position: 'relative',
        display: "flex",
        width: "36.8vw",
        height: "6vh",
        backgroundColor: "#f0f1f5",
        borderRadius: "100vw",
        borderColor: "#ebebeb",
        borderStyle: "solid",
        borderWidth: "2px"
      },
      searchIcon: {
        padding: theme.spacing(0, 2),
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
      inputRoot: {
        color: 'inherit',
      },
      inputInput: {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('md')]: {
          width: '20ch',
        },
      },
}))

const MAX_RESULTS = 7

const Searchbar = () => {
    const classes = useStyles();
    const history = useHistory()
    const [query, setQuery] = useState("")
    const [searchResults, setSearchResults] = useState([]);
    // Index of the row highlighted with the arrow keys (-1 = none).
    const [activeIndex, setActiveIndex] = useState(-1)
    const resultsRef = useRef(null)
    const tasksRef = useRef(null)

    // The dropdown chrome (shadow + spacing) follows whether there are rows to show.
    useEffect(() => {
        const results = resultsRef.current
        const tasks = tasksRef.current
        if (!results || !tasks) return
        if (searchResults.length) {
            results.style.boxShadow = "-3px 4px 2px whitesmoke, 3px 4px 2px whitesmoke";
            tasks.style.marginTop = "2vh";
            tasks.style.marginBottom = "2vh";
        } else {
            results.style.boxShadow = "revert";
            tasks.style.marginTop = "0px";
            tasks.style.marginBottom = "0px";
        }
    }, [searchResults])

    const searchTasks = (e) => {
        const value = e.target.value
        setQuery(value)
        setSearchResults(searchItems(value, MAX_RESULTS))
        setActiveIndex(-1)
    }

    const clearSearch = () => {
        setQuery("")
        setSearchResults([])
        setActiveIndex(-1)
    }

    // Search results navigate through the router like every other entry point,
    // so /?process=... opens the same modal the Quick Task tiles open.
    const goToResult = (path) => {
        clearSearch()
        history.push(path)
    }

    // Enter opens the highlighted row (or the first one); with no rows it opens
    // the search results page for the query (QA issue 1).
    const onKeyDown = (e) => {
        if (e.key === "ArrowDown") {
            if (!searchResults.length) return
            e.preventDefault()
            setActiveIndex((activeIndex + 1) % searchResults.length)
        } else if (e.key === "ArrowUp") {
            if (!searchResults.length) return
            e.preventDefault()
            setActiveIndex(activeIndex <= 0 ? searchResults.length - 1 : activeIndex - 1)
        } else if (e.key === "Enter") {
            e.preventDefault()
            if (searchResults.length) {
                goToResult(searchResults[activeIndex >= 0 ? activeIndex : 0].path)
            } else if (query.trim()) {
                const q = query.trim()
                clearSearch()
                history.push(`/search?q=${encodeURIComponent(q)}`)
            }
        } else if (e.key === "Escape") {
            clearSearch()
        }
    }

    const activeId = activeIndex >= 0 ? `search-result-${activeIndex}` : undefined

    return (
        <div className="searchContainer" id="searchContainer">
            <div id="results" ref={resultsRef}>
              <div className={classes.search} id="searchBar">
                  <div className={classes.searchIcon}>
                    <SystemIcon size={"3vh"} icon={searchIcon} />
                  </div>
                  <InputBase
                  placeholder="Search"
                  style={{fontSize: "15px", width: "40vw"}}
                  classes={{
                      root: classes.inputRoot,
                      input: classes.inputInput,
                  }}
                  id="searchInput"
                  value={query}
                  onChange={searchTasks}
                  onKeyDown={onKeyDown}
                  inputProps={{
                      'aria-label': 'search',
                      role: 'combobox',
                      'aria-autocomplete': 'list',
                      'aria-controls': 'tasks',
                      'aria-expanded': searchResults.length > 0,
                      'aria-activedescendant': activeId,
                      autoComplete: 'off'
                  }}

                  />
              </div>
              <div id="tasks" ref={tasksRef} role="listbox" aria-label="Search results">
                  {searchResults.map(function(searchResult, key) {
                    const active = key === activeIndex
                    return <div
                      className={active ? "task task-active" : "task"}
                      id={`search-result-${key}`}
                      role="option"
                      aria-selected={active}
                      key={searchResult.path}
                      onMouseEnter={() => setActiveIndex(key)}
                      onMouseDown={(e) => e.preventDefault()}
                      onClick={() => goToResult(searchResult.path)}
                    >
                      <SystemIcon size={"3.5vh"} icon={clipboardIcon} />
                        <div className="task-text">
                          <p style={{fontSize: "15px"}}>{searchResult.title}</p>
                          <p style={{fontSize: "14px", color: "gray"}}>{searchResult.type}</p>
                        </div>
                    </div>
                  })}
              </div>
            </div>
            <div></div>
        </div>
    );
};


export default Searchbar;
